import { useEffect, useState } from 'react';
import { Activity, Loader2 } from 'lucide-react';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import api from '../lib/api';

const tooltipStyle = { background: '#121a23', border: '1px solid rgba(255,255,255,.18)', borderRadius: 6, color: '#fff', fontSize: 12 };
const label = (day) => day ? new Date(`${day}T00:00:00`).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }) : '';

export const PlatformRolloutChart = ({ targetVersion }) => {
  const [data, setData] = useState(null);
  const [selected, setSelected] = useState(targetVersion || '');
  const [error, setError] = useState(false);

  useEffect(() => { if (!selected && targetVersion) setSelected(targetVersion); }, [selected, targetVersion]);
  useEffect(() => {
    if (!selected) return;
    setError(false); setData(null);
    api.get('/platform/installations/rollout/chart', { params: { version: selected, days: 45 } })
      .then(r => setData(r.data)).catch(() => setError(true));
  }, [selected]);

  const points = (data?.series || []).map(p => ({ ...p, label: label(p.day) }));
  return (
    <div className="pc-card" style={{ marginBottom: '1.1rem' }} data-testid="pc-rollout-chart">
      <div className="pc-card-h" style={{ alignItems: 'center', gap: '.7rem', flexWrap: 'wrap' }}>
        <div><h2><Activity className="pc-inline-icon" />Update adoption pace</h2><p className="pc-sub" data-testid="pc-rollout-chart-summary">Day-by-day till movement toward each released version.</p></div>
        <select className="pc-select" value={selected} onChange={(e) => setSelected(e.target.value)} data-testid="pc-rollout-chart-version">
          {(data?.versions || [targetVersion]).filter(Boolean).map(v => <option key={v} value={v}>{v}</option>)}
        </select>
      </div>
      <div style={{ height: 230, minWidth: 0, padding: '0 8px 12px' }} data-testid="pc-rollout-chart-plot">
        {!selected || (!data && !error) ? <div className="pc-empty"><Loader2 className="h-4 w-4 animate-spin" /></div>
          : error ? <p className="pc-empty" data-testid="pc-rollout-chart-error">Could not load adoption history.</p>
            : points.length ? <ResponsiveContainer width="100%" height="100%"><LineChart data={points} margin={{ top: 12, right: 12, left: -20, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="rgba(255,255,255,.10)" />
              <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#b9c7d6' }} axisLine={false} tickLine={false} minTickGap={28} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#b9c7d6' }} axisLine={false} tickLine={false} />
              <Tooltip contentStyle={tooltipStyle} labelStyle={{ color: '#fff' }} />
              <Legend wrapperStyle={{ fontSize: 11, color: '#dce6ef' }} />
              <Line type="monotone" dataKey="updated" name="Updated" stroke="#52e0b8" strokeWidth={2.5} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="behind" name="Needs update" stroke="#ffcf72" strokeWidth={2.5} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="unknown" name="Unknown" stroke="#b9c7d6" strokeDasharray="4 3" dot={false} />
            </LineChart></ResponsiveContainer>
              : <p className="pc-empty" data-testid="pc-rollout-chart-empty">The first adoption checkpoint will appear once a till reports this version.</p>}
      </div>
    </div>
  );
};